export default __webpack_public_path__ + "static/media/dashboard-emails.feacdd82.svg";